import React, { useEffect, useRef, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import TitleComp from "../Component/TitleComp";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";

import { Button, Col, Form, FormGroup, Modal } from "react-bootstrap";
import { Base_Url } from "../BaseUrl";
import { Bars } from "react-loader-spinner";
import { ToastContainer, toast } from "react-toastify";
import { compressImage } from "../Component/CompressImage";
import Select from "react-select";

function BrandModel() {
  const [categories, setCategories] = useState([]);
  const fileInputRef = useRef(null);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectbrandoption, setselectbrandoption] = useState([]);
  const [selectcatfilter, setselectcatfilter] = useState([]);
  const [selectbrandfilter, setselectbrandfilter] = useState([]);



  const [activeBrand, setActiveBrand] = useState(null);
  const [name, setname] = useState("");
  const [file, setfile] = useState(null);
  const [idindex, setidindex] = useState("");
  const [editimg, seteditimg] = useState("");
  const [loading, setloading] = useState(false);
  const [brand, setbrand] = useState([]);
  const [brandvalue, setbrandvalue] = useState("");
  const [catvalue, setcatvalue] = useState("");
  const [brandfilter, setbrandfilter] = useState([])

  const [filter, setfilter] = useState([]);
  let token = localStorage.getItem("token");
  const [cat, setcat] = useState([])
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const categoriesget = () => {
    axios.get(`${Base_Url}/categories`, { headers }).then((res) => {
      // console.log(res.data.data);
      setcat(res.data.data);
    });
  };

  const options = cat.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const brandoptions = brand.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const brandfilteroptions = brandfilter.map((item) => ({
    value: item._id,
    label: item.name,
  }));


  const handleSelectChange = (selectedValues) => {
    setSelectedOptions(selectedValues);
  };
  const handleSelectbrandChange = (selectedValues) => {
    setselectbrandoption(selectedValues);
  };



  const handlecatfilter = (selectedValues) => {
    setselectcatfilter(selectedValues);
  };
  const handlebrandfilter = (selectedValues) => {
    setselectbrandfilter(selectedValues);
  };



  useEffect(() => {
    categoriesget()
  }, [])

  const [imageurl, setimageurl] = useState("")


  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (e, value) => {
    setShow(true)
    setimageurl(value)
  };

  const handlesubmit = (e) => {
    setloading(true);
    e.preventDefault();

    let formdata = new FormData();

    formdata.append("name", name);
    if (file) {
      formdata.append("image", file);
    }
    formdata.append("brand", selectbrandoption.value);
    formdata.append("category", selectedOptions.value)
    if (idindex) {
      formdata.append("_id", idindex);
      axios
        .put(`${Base_Url}/brand_models`, formdata, { headers })
        .then((res) => {
          // console.log(res);
          if (res.data !== null) {
            setloading(false);
            catgoryget();
            handleClear();
            setActiveBrand("");
            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }
            seteditimg("")
          }
        });
    } else {
      axios
        .post(`${Base_Url}/brand_models`, formdata, { headers })
        .then((res) => {
          // console.log(res);
          if (res.data !== null) {
            setloading(false);
            catgoryget();
            handleClear();
            setActiveBrand("");
            if (fileInputRef.current) {
              fileInputRef.current.value = '';
            }
          }
        });
    }
  };



  // const handlesubmit = (e) => {
  //   setloading(true);
  //   e.preventDefault();
  //   let formdata = new FormData();

  //   formdata.append("name", name);
  //   formdata.append("image", file);
  //       formdata.append("brand", brandvalue);
  //   if (file) {
  //     compressImage(file).then((compressedFile) => {
  //       formdata.append("image", compressedFile);
  //       formdata.append("brand", brandvalue);
  //       if (idindex) {
  //         formdata.append("_id", idindex);
  //         axios.put(`${Base_Url}/brand_models`, formdata, { headers }).then((res) => {
  //           if (res.data !== null) {
  //             setloading(false);
  //             catgoryget();
  //             handleClear();
  //           }
  //         });
  //       } else {
  //         axios.post(`${Base_Url}/brand_models`, formdata, { headers }).then((res) => {
  //           if (res.data !== null) {
  //             setloading(false);
  //             catgoryget();
  //             handleClear();
  //           }
  //         });
  //       }
  //     });
  //   }
  // };



  const handleFile = (e) => {
    const selectedfile = e.target.files[[0]];
    // console.log(selectedfile);
    setfile(selectedfile);
  };

  const catgoryget = () => {
    setloading(true);
    axios.get(`${Base_Url}/brand_models`, { headers }).then((res) => {
      setCategories(res.data.data);
      if (res.data !== null) {
        setloading(false);
      }
    });
  };
  useEffect(() => {
    catgoryget();
  }, []);

  const handleedit = (e, id) => {
    e.preventDefault();
    // console.log("od", id);
    // Filter categories based on the ID
    const editFilter = categories.find((cat) => cat?._id == id);
    // console.log("editfilter", editFilter);
    if (editFilter) {
      // Set state values using the filtered category
      setidindex(editFilter._id);
      seteditimg(editFilter.image);
      setbrandvalue(editFilter.brand?._id);
      setname(editFilter.name);
    }
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleClear = () => {
    setname("");
    setfile(null);
    setbrandvalue("");
  };

  const getRowId = (row) => row._id;
  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    {
      field: "brand",
      headerName: "Brand",
      flex: 1,
      valueGetter: (params) => {
        return params.row?.brand ? params.row?.brand.name : "";
      },
    },

    {
      field: "image",
      headerName: "image",
      flex: 1,
      renderCell: (params) => {
        const { value } = params;
        return (
          <img
            src={`${Base_Url}/${value}`}
            onClick={(e) => handleShow(e, value)}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
            }}
            className="img-fluid tableimgmui"
          ></img>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => {
        // const index = params.row.index; // Corrected to rowIndex
        const id = params.row._id;
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => handleedit(e, id)}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
        );
      },
    },

    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDelete(e, id);
            }}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
        );
      },
    },
  ];

  const brandget = () => {
    axios.get(`${Base_Url}/brands`, { headers }).then((res) => {
      // console.log(res.data.data);

      let collectdata = []
      let filtervalue = []

      if (selectedOptions != "") {
        collectdata = res.data.data.filter((item) => {
          return item?.category?.[0]?._id == selectedOptions.value
        })
      } else {
        collectdata = res.data.data
      }

      if (selectcatfilter != "") {
        filtervalue = res.data.data.filter((item) => {
          return item?.category?.[0]?._id == selectcatfilter.value
        })
      } else {
        filtervalue = res.data.data
      }

      setbrand(collectdata)
      setbrandfilter(filtervalue)


    });
  };




  useEffect(() => {
    brandget();
    if (categories) {
      setfilter(categories);
    }
  }, [categories, selectedOptions, selectcatfilter]);




  const handlefilter = (e, selectedBrand) => {

    let filteredData = categories.filter(
      (cat) => cat?.brand?.category?.[0] === selectcatfilter.value
    );
    setfilter(filteredData);
    setselectbrandfilter([])

  };

  const handlebrandgetfilter = () => {
    let filteredData = categories.filter(
      (item) => item?.brand?._id === selectbrandfilter.value
    );
    setfilter(filteredData);
  }

  useEffect(() => {
    if (selectcatfilter != "") {
      handlefilter()
    }
  }, [selectcatfilter])

  useEffect(() => {
    if (selectbrandfilter != "") {
      handlebrandgetfilter()
    }
  }, [selectbrandfilter])

  const notify = (message, type) => {
    // console.log("type", type);
    toast[type](message, {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const handleDelete = (e, id) => {
    e.preventDefault();

    let requestdata = {
      _id: id,
      deleted_at: Math.floor(Date.now() / 1000),
    };

    axios
      .put(`${Base_Url}/brand_models`, requestdata, { headers })
      .then((res) => {
        console.log(res);
        if (res.data.message === "Ok") {
          catgoryget();
          toast.success("Deleted Successfully")
          setActiveBrand("")

          // console.log("Data", res.data); 
        }
      })
      .catch((error) => {
        console.error("Error deleting:", error);
        notify("Error deleting", "error");
      });
  };

  const handleall = () => {
    setselectcatfilter([])
    setselectbrandfilter([])
    setfilter(categories)
  }



  return (
    <>
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}

      <Sidebaar
        content={
          <>
            <TitleComp title="Add Sub Brand " />

            <Form className="my-5" onSubmit={(e) => handlesubmit(e)}>
              <div className="row align-items-center gy-3">
                {editimg && (
                  <Col md="12">
                    <div className="text-center mt-3 ">
                      <img
                        style={{ height: "50px" }}
                        src={`${Base_Url}/${editimg}`}
                        className="img-fluid rounded-2"
                      />
                    </div>
                  </Col>
                )}
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">
                      Image{" "}
                      {idindex ? "" : <span className="text-danger">*</span>}
                    </label>
                    <input
                      type="file"
                      required={idindex ? false : true}
                      onChange={(e) => handleFile(e)}
                      className="form-control"
                      ref={fileInputRef}
                    />
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup>
                    <label htmlFor="">Name</label>
                    <input
                      type="text"
                      value={name}
                      onChange={(e) => setname(e.target.value)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>


                <Col md='4'>
                  <label htmlFor="">Select Category</label>
                  <Select
                    options={options}
                    value={selectedOptions}
                    onChange={handleSelectChange}
                  />
                </Col>
                <Col md='4'>
                  <label htmlFor="">Select Brand</label>
                  <Select
                    options={brandoptions}
                    value={selectbrandoption}
                    onChange={handleSelectbrandChange}
                  />
                </Col>


                <Col md="2">
                  <button className="btn mt-4 bg-dark text-white">
                    Submit{" "}
                  </button>
                </Col>
              </div>
            </Form>

            <div className="row  align-items-center">

              {/* {brand.map((item) => {
                    return (
                      <button
                        key={item._id}
                        className={`btn px-5 rounded-pill ${activeBrand && activeBrand._id === item._id
                          ? " bgblackgrd text-white"
                          : "bgbluegrd text-white"
                          }`}
                        onClick={(e) => handlefilter(e, item)}

                      >
                        
                        {item.name}
                      </button>
                    );
                  })} */}



              <Col md='4'>
                <label htmlFor="">Select Category</label>
                <Select
                  options={options}
                  value={selectcatfilter}
                  onChange={handlecatfilter}
                />
              </Col>

              <Col md='4'>
                <label htmlFor="">Select Brand</label>
                <Select
                  options={brandfilteroptions}
                  value={selectbrandfilter}
                  onChange={handlebrandfilter}
                />
              </Col>

              <div className="col-md-2">
                <button
                  className="btn bg-dark text-white mt-4"
                  onClick={(e) => {
                    handleall(e)
                  }}
                >
                  Show All
                </button>
              </div>
            </div>

            <Col md="12">
              <Box sx={{ height: 500, width: "100%" }}>
                <DataGrid
                  //   rows={data} // Update this line
                  rows={filter.map((row, index) => ({
                    ...row,
                    index,
                  }))}
                  columns={columns}
                  pageSize={5}
                  getRowId={getRowId}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 10 } },
                  }}
                  pageSizeOptions={[5, 10, 25]}
                />
              </Box>
            </Col>
            <ToastContainer />

            <Modal show={show} size="md" onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Image</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img src={`${Base_Url}/${imageurl}`} alt="" />
              </Modal.Body>
              <Modal.Footer>
                <Button className="text-write bg-secondary  shadow-none border-0" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        }
      />
    </>
  );
}

export default BrandModel;







